"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainFooterWithOnlyTodayControl = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("../../../../../../helpers/constants");
const Dialog_1 = require("../../../../../../../../Dialog");
const icons_1 = require("../../../../../../../../icons");
exports.MainFooterWithOnlyTodayControl = react_1.default.memo(function MainFooterWithOnlyTodayControl({ isTodayDisabled, onToday, onMouseDown, texts }) {
    const uiTexts = Object.assign({ today: constants_1.DEFAULT_TEXTS.today }, texts);
    return (react_1.default.createElement(Dialog_1.DialogActions, { secondary: [
            {
                id: constants_1.dataSelectorId.todayControl,
                text: uiTexts.today,
                disabled: isTodayDisabled,
                iconSrc: react_1.default.createElement(icons_1.TodayIcon, null),
                view: Dialog_1.ACTION_VIEW.text,
                onClick: onToday
            }
        ], onMouseDown: onMouseDown }));
});
//# sourceMappingURL=MainFooterWithOnlyTodayControl.js.map